<script setup>
	import { defineProps } from 'vue'

	const props = defineProps({
		item: Object,
		required: true
	})

	const emit = defineEmits(['add'])

	function currencyFormat(value) {
	  return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value)
	}

	function handleAddClick() {
	  emit('add', { item: props.item })
	}
</script>

<template>
	<div class="item">
		<div class="grow">
			<h2>{{ item.title }}</h2>
			<p>{{ item.description }}</p>
			<span>{{ currencyFormat(item.price) }}</span>
		</div>
	    <div class="w-[35%] self-center shrink-0 relative after:content-[''] after:pt-[100%] after:block">
	      <img 
	        v-lazy="{ 
	          src: item.photo, 
	          loading: 'img/image_loader.gif', 
	          error: 'img/no_image.png' 
	        }" 
	      />
	      <button @click="handleAddClick">+</button>
	    </div>
	</div>
</template>

<style scoped>
	/*
    **ITEM CARD
    */
    .item {
        @apply bg-white dark:bg-zinc-700 p-3 mx-2 my-1 rounded-3xl grow shadow-md shadow-zinc-200/50 dark:shadow-zinc-900/50 border border-zinc-200/50 dark:border-zinc-900/50 flex;
    }
    .item img {
       @apply absolute top-0 left-0 w-full h-full object-cover rounded-3xl;
    }

    .item h2 {
        @apply text-sm font-semibold;
    }

    .item p {
        @apply text-sm text-zinc-400 mt-1 mb-3 pe-1;
    }

    .item span {
        @apply text-xl font-semibold text-[var(--color)];
    }

    .item button {
        @apply absolute bottom-2 right-2 text-white rounded-full bg-[var(--color)] shadow-md shadow-zinc-200/50 dark:shadow-zinc-900/50 w-8 h-8;
    }
</style>